export function getLastWord(words) {
  if (words && words.length > 0) {
    const n = words.split(" ")
    return n[n.length - 1]
  }
}
